
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faThumbsUp,
  faCheck,
  faReply,
  faEllipsis,
  faUser,
  faMusic,
  faBars,
  faSpinner,
  faCaretUp,
  faCaretDown,
  faEdit,
  faTrash,
  faClock,
  faSortAlphaDown,
} from "@fortawesome/free-solid-svg-icons"

library.add(
  faThumbsUp,
  faCheck,
  faReply,
  faEllipsis,
  faUser,
  faMusic,
  faBars,
  faSpinner,
  faCaretUp,
  faCaretDown,
  faEdit,
  faTrash,
  faClock,
  faSortAlphaDown,
)